// extracted by mini-css-extract-plugin
export var resizer = "_en-0";